module.exports = __webpack_public_path__ + "img/logo-duvenbeck.8057c95.png";